import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
  standalone: true,
  pure: true,
})
export class TruncateTextPipe implements PipeTransform {
  transform(value: string, limit: number = 400): { text: string; isTruncated: boolean } {
    if (!value) return { text: '', isTruncated: false };
    if (value.length > limit) {
      let truncated = value.substr(0, limit);
      // Asegurarse de no cortar en medio de una etiqueta HTML
      truncated = truncated.substr(0, Math.min(truncated.length, truncated.lastIndexOf(' ')));
      return { text: truncated + '...', isTruncated: true };
    }
    return { text: value, isTruncated: false };
  }
}